<template>
  <v-icon @click="emitUpdateDialogAction" class="actions_small"
    >mdi-pause</v-icon
  >
  <v-dialog
    v-model="dialogTraineeAction"
    transition="dialog-top-transition"
    persistent
    max-width="800"
    min-width="400"
  >
    <v-card class="rounded-lg pa-4" color="dialog">
      <v-card-title class="headline">{{ ActionPauseTitle }}</v-card-title>
      <v-card-text>
        <div class="field_form">
          <label for="debutDePause" class="label_datePicker"
            >Début de la pause :
          </label>
          <input
            type="date"
            id="debutDePause"
            v-model="newSelectedBeginPauseDate"
          />
        </div>
        <div class="field_form">
          <label for="finDePause" class="label_datePicker"
            >Date de Reprise :
          </label>
          <input type="date" id="finDePause" v-model="newSelectedResumeDate" />
        </div>
        <div class="field_form">
          <label for="nouvelleDateDeFin" class="label_datePicker"
            >Nouvelle Date de fin de formation :
          </label>
          <input
            type="date"
            prepend-icon="mdi-calendar"
            id="NouvelleDateDeFin"
            v-model="newSelectedEndDate"
          />
        </div>
        <br />
        <div class="field_form">
          <label for="nouvelledateExamen" class="label_datePicker"
            >Nouvelle Date d'Examen (optionel):
          </label>
          <input
            type="date"
            prepend-icon="mdi-calendar"
            id="nouvelledateExamen"
            v-model="newExamDate"
          />
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialogTraineeAction = false"
          >Annuler</v-btn
        >
        <v-btn
          color="primary"
          text
          @click="
            pauseTrainingSession(
              field,
              item,
              newSelectedBeginPauseDate,
              newSelectedResumeDate,
              newSelectedEndPause,
              newSelectedEndDate,
              newExamDate
            ),
              (dialogTraineeAction = false)
          "
          >Confirmer</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="5000">
    <p v-html="snackbarMessage"></p>
  </v-snackbar>
</template>

<script>
import authExpirationMixin from "@/mixins/isLogged.js";

import axios from "axios";
import {
  base_url,
  trainingblocsubscriptions_urls,
  header,
} from "@/API/config.js";

export default {
  mixins: [authExpirationMixin],

  props: {
    ActionPauseTitle: String,
    item: Object,
    traineesData: {
      type: Array,
      required: true,
    },
  },
  emits: [
    "refresh-training-subscriptions",
    "selected-begin-pause",
    "selected-resume-date",
    "selected-end-date-changed",
    "exam-date-changed",
    "handleSelectedEndDateChanged",
    "handleExamDateChanged",
    "handleSelectedBeginPause",
    "handleSelectedResumeDate",
  ],
  data() {
    return {
      dialogTraineeAction: false,
      newSelectedEndDate: null,
      newSelectedBeginPauseDate: null,
      newSelectedResumeDate: null,
      newSelectedExamDate: null,
      selectedEndPause: null,
      selectedExamDate: null,
      newExamDate: null,
      newBeginPauseDate: null,
      newResumeDate: null,
      snackbar: false,
      snackbarMessage: "",
      snackbarColor: "success",
    };
  },

  watch: {
    newSelectedBeginPauseDate(newBeginPauseDate) {
      this.$emit("selected-begin-pause", newBeginPauseDate);
    },

    newSelectedResumeDate(newResumeDate) {
      this.$emit("selected-resume-date", newResumeDate);
    },

    newSelectedEndDate(newEndDate) {
      this.$emit("selected-end-date-changed", newEndDate);
    },

    newExamDate(newExamDate) {
      this.$emit("exam-date-changed", newExamDate);
    },
  },

  methods: {
    async pauseTrainingSession(
      field,
      item,
      selectedBeginPauseDate,
      selectedResumeDate
    ) {
      try {
        const selectedTrainingBlocSubscription =
          item.ID_FS_TrainingBlocSubscription;

        const currentTrainingblocSubscription =
          await this.fetchCurrentSubscription(selectedTrainingBlocSubscription);

        const currentSubscriptionEnd = new Date(
          currentTrainingblocSubscription.DAT_SubscriptionEnd
        );

        const currentSubscriptionStart = new Date(
          currentTrainingblocSubscription.DAT_SubscriptionStart
        );

        const newSelectedBeginPauseDate = new Date(
          this.newSelectedBeginPauseDate
        );

        const newExamDate = this.newExamDate
          ? new Date(this.newExamDate)
          : null;

        const newSelectedResumeDate = new Date(this.newSelectedResumeDate);
        const newSubscriptionEnd = new Date(this.newSelectedEndDate);

        if (newSelectedBeginPauseDate < currentSubscriptionStart) {
          this.snackbarMessage = `La début de la pause doit commencer après à la date de début initiale.`;
          this.snackbarColor = "error";
          this.snackbar = true;
          return;
        }

        if (newSelectedBeginPauseDate > currentSubscriptionEnd) {
          this.snackbarMessage = `La début de la pause doit commencer avant à la date de fin initiale.`;
          this.snackbarColor = "error";
          this.snackbar = true;
          return;
        }

        if (newSelectedResumeDate < newSelectedBeginPauseDate) {
          this.snackbarMessage = `La date de reprise commencer après la pause.`;
          this.snackbarColor = "error";
          this.snackbar = true;
          return;
        }

        if (newSubscriptionEnd < newSelectedResumeDate) {
          this.snackbarMessage = `La nouvelle date de fin doit être postérieure à la date de reprise.`;
          this.snackbarColor = "error";
          this.snackbar = true;
          return;
        }

        const urlUpdate = `${base_url}${trainingblocsubscriptions_urls.get_details(
          selectedTrainingBlocSubscription
        )}`;

        const pauseSubscriptionUpdate = {
          DAT_SubscriptionEnd: selectedBeginPauseDate,
          BIT_Cancelled: true,
          TXT_SubscriptionStatus: "pause",
        };

        await axios.put(urlUpdate, pauseSubscriptionUpdate, header);

        const resumeSubscription = {
          DAT_SubscriptionStart: selectedResumeDate,
          DAT_SubscriptionEnd: this.newSelectedEndDate,
          DAT_SubscriptionDate: new Date().toISOString().split("T")[0],
          DAT_FinalTestScheduled: newExamDate
            ? newExamDate.toISOString().split("T")[0]
            : null,
          TXT_SubscriptionStatus: "reprise",
          BIT_Extention: false,
          BIT_Resumption: true,
          BIT_Cancelled: false,
          ID_D_Trainee: currentTrainingblocSubscription.ID_D_Trainee,
          ID_D_TrainingBloc: currentTrainingblocSubscription.ID_D_TrainingBloc,
          ID_Subscription: currentTrainingblocSubscription.ID_Subscription,
          TXT_Cohort: currentTrainingblocSubscription.TXT_Cohort,
        };

        const urlCreate = `${base_url}${trainingblocsubscriptions_urls.post}`;
        await axios.post(urlCreate, resumeSubscription, header);

        this.snackbarMessage =
          "La formation a été mise en pause et reprise avec succès.";
        this.snackbarColor = "success";
        this.snackbar = true;
        this.$emit("refresh-training-subscriptions");
      } catch (error) {
        this.snackbarMessage = `Erreur lors de la mise en pause de la formation : ${error.message}`;
        this.snackbarColor = "error";
        this.snackbar = true;
        console.error(
          "Erreur lors de la mise en pause de la formation:",
          error
        );
      }
      this.dialogTraineeAction = false;
    },

    // --- Méthodse liées --- //

    emitUpdateDialogAction() {
      this.dialogTraineeAction = true;
    },

    async fetchCurrentSubscription(selectedTrainingBlocSubscription) {
      const url = `${base_url}${trainingblocsubscriptions_urls.get_details(
        selectedTrainingBlocSubscription
      )}`;
      const CurrentSubscription = await axios.get(url, header);
      return CurrentSubscription.data;
    },

    async pauseCurrentSubscription(selectedTrainingBlocSubscription) {
      const url = `${base_url}${trainingblocsubscriptions_urls.get_details(
        selectedTrainingBlocSubscription
      )}`;

      const updatedSubscription = {
        ...this.CurrentSubscription,
        BIT_Cancelled: true,
      };

      try {
        await axios.put(url, updatedSubscription, header);
      } catch (error) {
        console.error(
          "Erreur lors de la mise en pause de la souscription :",
          error
        );
      }
    },

    handleSelectedEndDateChanged(newEndDate) {
      this.newSelectedEndDate = newEndDate;
      this.$emit("update:endDate", newEndDate);
    },
    handleExamDateChanged(newExamDate) {
      this.selectedExamDate = newExamDate;
      this.$emit("update:examDate", newExamDate);
    },

    handleSelectedBeginPause(newBeginPauseDate) {
      this.selectedBeginPauseDate = newBeginPauseDate;
      this.$emit("update:beginPauseDate", newBeginPauseDate);
    },

    handleSelectedResumeDate(newResumeDate) {
      this.selectedResumeDate = newResumeDate;
      this.$emit("update:resumeDate", newResumeDate);
    },
  },
};
</script>
